<template lang="pug">
  #container
    #map
    canvas#deck-canvas
    //- #tooltip(style="position: absolute; z-index: 1; pointer-events: none;") {{ this.lng }}
    SideBar(:counter="counter", :isRunning="isRunning", :inTransition="inTransition", :isOpen="sideBarIndex")
    .loading-screen(v-if="stateIndex == 0")
      .gym_heatmap
        .loading-screen-text
          h1 Fitness Consumer Study
          h3 Los Angeles County - 2019
        b-button.is-large.get-started.rounded-0(@click="start()") Get Started
    .details-srceen(v-if="stateIndex == 7")
      img(src="@/assets/5be267a03f7813daf821b31e_safegraph-logo-hidpi@3x-p-500.png")
      img.oniracom-logo(src="@/assets/head_vertical.png")
    b-button.nextButton.btn.btn-square.btn-primary(v-if="stateIndex == 1 && inTransition == false", @click="viewBuildings()") Learn about the gyms &gt;
    b-button.nextButton.btn.btn-square.btn-primary(v-if="stateIndex == 5 && inTransition == false", @click="playDay()") A Day in the Life of One Gym &gt;
    b-button.replayButton.btn.btn-square.btn-primary(v-if="stateIndex == 6 && inTransition == false && isRunning == false", @click="start()") Play Again 
      i.fa.fa-redo
    b-button.nextButton.btn.btn-square.btn-primary(v-if="stateIndex == 6 && inTransition == false && isRunning == false" , @click="showDetails()") The Details &gt;
</template>

<script>

import { LinearInterpolator, FirstPersonView, MapView } from "@deck.gl/core";
import { ScatterplotLayer, IconLayer, GeoJsonLayer } from "@deck.gl/layers";
import { TripsLayer } from "@deck.gl/geo-layers";
import mapboxgl from "mapbox-gl";
import gym_points from "@/assets/gym_points";

import SideBar from "@/components/SideBar";
import NextButton from "@/components/NextButton";

import { all } from 'q';

import CONSTS from "@/config"

mapboxgl.accessToken = 'pk.eyJ1Ijoib25pcmFjb20iLCJhIjoiY2oyeHk0ODk4MDAwMTJxbzJyMW5nZTlmaSJ9.amZiihhUvpe0LlmvFh7-1Q'; // eslint-disable-line

// Converts from degrees to radians.
function toRadians(degrees) {
  return degrees * Math.PI / 180;
};
 
// Converts from radians to degrees.
function toDegrees(radians) {
  return radians * 180 / Math.PI;
}


function bearing(startLat, startLng, destLat, destLng){
  startLat = toRadians(startLat);
  startLng = toRadians(startLng);
  destLat = toRadians(destLat);
  destLng = toRadians(destLng);

  let y = Math.sin(destLng - startLng) * Math.cos(destLat);
  
  let x = Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
  let brng = Math.atan2(y, x);
  brng = toDegrees(brng);
  return (brng + 360) % 360;
}
// const gyms_data_file = "traces_fitness-samp0-m.json";



function getViewTiltTowardsGym() {
  let bearing_dir = bearing(CONSTS.VIEW_TILT_SM.latitude, CONSTS.VIEW_TILT_SM.longitude, gyms[0].position.latitude, gyms[0].position.longitude)
  
  return {
    ...CONSTS.VIEW_TILT_SM,
    bearing: bearing_dir
  }
}

function getMoveTowardsGym() {
  let bearing_dir = bearing(CONSTS.VIEW_TILT_SM.latitude, CONSTS.VIEW_TILT_SM.longitude, gyms[0].position.latitude, gyms[0].position.longitude)
  
  return {
    ...CONSTS.VIEW_TILT_SM,
    bearing: bearing_dir,
    latitude: gyms[0].position.latitude,
    longitude: gyms[0].position.longitude,
    pitch: 90,
    zoom: 16
  }
}

function getLookDownOnGym() {
  let bearing_dir = bearing(CONSTS.VIEW_TILT_SM.latitude, CONSTS.VIEW_TILT_SM.longitude, gyms[0].position.latitude, gyms[0].position.longitude)
  
  return {
    ...CONSTS.VIEW_TILT_SM,
    bearing: bearing_dir,
    latitude: gyms[0].position.latitude,
    longitude: gyms[0].position.longitude,
    pitch: 30,
    zoom: 13
  }
}

function generateBuildingLayer(options) {
  console.log('transitions',options.transitions)
  return new GeoJsonLayer({
    id: "geojson-layer",
    data: json_data[options.data],
    pickable: false,
    stroked: false,
    filled: true,
    extruded: true,
    // opacity: (typeof options.opacity == 'number' ? options.opacity : 1),
    lineWidthScale: 20,
    lineWidthMinPixels: 2,
    getFillColor: options.fillColor,
    getLineColor: [160, 160, 180, 0],
    getRadius: 100,
    getLineWidth: 10,
    getElevation: options.elevation,
    transitions: options.transitions
  });
}

// var iconlayer;
var gyms;
// var buildingLayer;
// var allBuildngsLayer;
var deck;

var json_data = {
  allBuildingsJson: null,
  allBuildingsButOneJson: null,
  targetGymJson: null
}

/*
// 5000 ms over range of 0-1.  update 100 ms
function updateMapMove(t) {
  // deck.setState(currentView);
  let buildingsLayer = generateBuildingLayer(1 - t, allBuildingsJson);
  deck.setProps({ layers: buildingsLayer });
  // console.log(t);
  if (t < 1) {
    setTimeout(() => {
      updateMapMove(t + 1 / 50);
    }, 100);
  }
}
*/
const statePlanner = [
  /* 0 */ {},
  /* 1 */ {layers: [CONSTS.getBoundaryLayer], options: [], view: CONSTS.INITIAL_VIEW_STATE, duration: 1000 },

  /* 2 */ {layers: [/*getBuildingHalosLayer, */ generateBuildingLayer], options: [/*ALL_HALOS_COLOR,*/ {fillColor: CONSTS.ALL_FILL_COLOR, elevation:1, transitions:{}, data: 'allBuildingsJson'}], view: CONSTS.VIEW_STATE_2, duration: 3000 },

  /* 3 */ {layers: [/*getBuildingHalosLayer, */generateBuildingLayer, generateBuildingLayer], options:[/*ALL_HALOS_COLOR, */{fillColor: CONSTS.ALL_FILL_COLOR, elevation:1, transitions: {}, data: 'allBuildingsButOneJson'}, {fillColor: CONSTS.TARGET_FILL_COLOR, elevation:1, transitions: {}, data: 'targetGymJson'}], view: getViewTiltTowardsGym, duration: 3000},

  /* 4 */ {layers: [], view: getMoveTowardsGym, duration: 3000},

  /* 5 */ {layers: [], view: getLookDownOnGym, duration: 3000},

  /* 6 */ {layers: [generateBuildingLayer, generateBuildingLayer], options:[ {opacity: 0, fillColor: [254,160,0,0], elevation: 1, transitions: {getFillColor: {duration: 1000, enter: value => {return CONSTS.ALL_FILL_COLOR} }},  data: 'allBuildingsButOneJson'}, {fillColor: CONSTS.TARGET_FILL_COLOR, elevation:1, transitions: {}, data: 'targetGymJson'} ], view: null, duration: 1000}

  // {layers: [generateBuildingLayer], options:[{opacity:200, elevation:1000, transitions:{getElevation: { duration: 5000 , enter: value => [0] }}}], view: null, duration: 7000}
];

// 0 - start
// 1 - show all gyms
// 2 - fly to gym
// 3 - gym pulse

export default {
  components: {
    SideBar,
    NextButton
  },
  data() {
    return {
      // deck: null,
      maxCount: 0,
      maxLat: 0,
      maxLng: 0,
      counter: 400,
      isRunning: false,
      interval: null,
      currentBuildingHeight: 1,
      inTransition: true,
      stateIndex: 0,
      sideBarIndex: 0
    };
  },
  created() {
    this.$on('learnAboutGyms', () => {
      this.viewBuildings()
    })
    this.$on('dayInTheLife', () => {
      this.playDay()
    })
  },
  mounted() {
    this.$http
      // .get("data/fitness_all.geojson")
      .get(CONSTS.DATA_HOST + "/gyms/fitness_all.php")
      .then(r => r.body)
      .then(all_json => {
        // console.log('woo', all)
        json_data.allBuildingsJson = all_json;
      });

    this.$http
      // .get("data/" + gyms_data_file)
      .get(CONSTS.DATA_HOST + "/gyms/traces.php")
      .then(r => r.body)
      .then(json => {
        gyms = json;
      });

    this.$http.get(CONSTS.DATA_HOST + "/gyms/all_gyms_but_one.php")
      .then(r => r.body).then(buildings_json => {
        json_data.allBuildingsButOneJson = buildings_json
      });

    this.$http.get(CONSTS.DATA_HOST + "/gyms/target_gym.php")
      .then(r => r.body).then(building_json => {
        json_data.targetGymJson = building_json
      });

    


    const map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/uberdata/cjfxhlikmaj1b2soyzevnywgs",
      // Note: deck.gl will be in charge of interaction and event handling
      interactive: false,
      center: [CONSTS.INITIAL_VIEW_STATE.longitude, CONSTS.INITIAL_VIEW_STATE.latitude],
      zoom: CONSTS.INITIAL_VIEW_STATE.zoom,
      bearing: CONSTS.INITIAL_VIEW_STATE.bearing,
      pitch: CONSTS.INITIAL_VIEW_STATE.pitch
    });

    deck = CONSTS.getDeck([], map, this.click, CONSTS.INITIAL_VIEW_STATE);
  },
  methods: {
    showDetails() {
      this.stateIndex = 7;
    },
    viewBuildings() {
      
      console.log('show buildings')
      var that = this;
      
      if (!this.inTransition) { 
        this.sideBarIndex = 2;
        this.stateIndex = 2;
        console.log('show buildings 1')
        this.runState(function() {
          console.log('show buildings 2')
          that.stateIndex = 3;
          that.runState(function() {
            console.log('show buildings 3')
            that.stateIndex = 4
            that.runState(() => {
              that.stateIndex = 5
              that.runState()
            })
          })
        });
      }
    },
    playDay() {
      if (!this.inTransition) {
        this.sideBarIndex = 3;
        this.stateIndex = 6;
        this.runState(() => {
          this.toggleRun()
        });
      }
    },
    runState(callback) {
      console.log('runstate',this.stateIndex)
      // move counter forward + loop
      /*
      this.stateIndex++
      if (this.stateIndex > statePlanner.length-1) {
        this.stateIndex = 0
      }
      */
      // construct viewstate object
      let theState = statePlanner[this.stateIndex]
      let viewState = null;
      if (typeof theState.view == 'function') {
        viewState = {
          ...theState.view(),
          transitionDuration: theState.duration,
          transitionInterpolator: new LinearInterpolator()
        }
      } else if (theState.view !== null) {
        viewState = {
          ...theState.view,
          transitionDuration: theState.duration,
          transitionInterpolator: new LinearInterpolator()
        }
      }
      console.log(viewState)
      // construct layers
      let layers = []
      for(let i = 0; i < theState.layers.length; i++) {
        //handle options
        if (theState.options.length >= i+1) {
          // check if options are null or call them
          if (theState.options[i] !== null) {
            layers.push(theState.layers[i](theState.options[i]))
          } else {
            layers.push(theState.layers[i]())
          }
        } else {
          // no options, just call the layer
          layers.push(theState.layers[i]())
        }
      }
      //push to deck
      if ((viewState !== null) && (layers.length > 0)) {
        deck.setProps({ layers: layers, viewState: viewState });
      } else if (viewState !== null) {
        deck.setProps({viewState: viewState})
      } else if (layers.length > 0) {
        deck.setProps({ layers: layers });
      }
      //hold for transition and optionally callback.
      this.inTransition = true;
      setTimeout(() => {
        this.inTransition = false;
        if (typeof(callback) == 'function') {
          callback()
        }
      }, theState.duration);
    },
    click(evt) {
      // console.log(this.stateIndex);
      // if (this.stateIndex < 1) {
      //   this.$emit('ShowBuildings')
      // } else if (this.stateIndex == 3) {
      //   this.$emit('ShowGymTrips')
      // }
    },
    start() {
      this.stateIndex = 1;
      this.sideBarIndex = 1;
      this.runState()
    },
    getHour: h => Math.floor(h / 60),
    run() {
      let that = this;
      return setInterval(() => {
        // let iconlayer = generateIconLayer(that.counter, gyms)
        // let layers = [iconlayer, buildingLayer];
        let layers = [];
        for (let gym of gyms) {
          
          let preTripsLayer = this.generateTripsLayer(
            "pre",
            gym.pre,
            gym.place_id
          );
          let postTripsLayer = this.generateTripsLayer(
            "post",
            gym.post,
            gym.place_id
          );
          // let textLayer = generateTextLayer(that.counter, map);
          let pulseLayers = this.generateGymPulse(
            gym.pulse,
            gym.position,
            gym.place_id
          );
          // let iconlayer = generateIconLayer(that.counter, gyms)
          layers = layers.concat([
            pulseLayers["Early"],
            pulseLayers["Mid"],
            pulseLayers["Late"],
            preTripsLayer,
            postTripsLayer
          ]);
        }
        that.counter++;
        deck.setProps({ layers: layers });
        if (that.counter >= 23 * 60) {
          // that.counter = 400;
          clearInterval(this.interval);
          this.isRunning = false;
        }
      }, 100);
    },
    toggleRun() {
      if (this.isRunning) {
        clearInterval(this.interval);
        this.isRunning = false;
      } else {
        if (this.counter >= 21 * 60) {
          this.counter = 400;
        }
        this.interval = this.run();
        this.isRunning = true;
      }
    },
    generateGymPulse(pulses, position, place_id) {
      let hasEnteredCount = pulses[this.counter];
      let plots = {};
      let opacity = Math.min((this.counter - 400) * 4, 255)
      for (let period in hasEnteredCount) {
        if (hasEnteredCount.hasOwnProperty(period)) {
          plots[period] = new ScatterplotLayer({
            id: "gym-" + period + "-" + place_id,
            getRadius: () => hasEnteredCount[period], //d.radius,
            getColor: () => {
              // return [253, 128, 93];
              switch (period) {
                case "Early":
                  return [253, 128, 93, opacity];
                case "Mid":
                  return [51, 153, 51, opacity];
                case "Late":
                  return [0, 153, 255, opacity];
              }
            },
            radiusMinPixels: 0,
            data: [
              {
                position: [position.longitude, position.latitude],
                color: [135, 174, 190],
                radius: 100
              }
            ]
          });
        }
      }
      return plots;
    },
    generateTripsLayer(type_type, trips, place_id) {
      let opacity = Math.min((this.counter - 400) * 0.001, 1)
      console.log('tripOpacity', opacity)
      return new TripsLayer({
        id: "trips-layer-" + type_type + "_" + place_id,
        // data: 'data/' + trips_data_file,
        data: trips,
        getPath: d => d.path,
        // deduct start timestamp from each data point to avoid overflow
        // getTimestamps: d => d.waypoints.map(p => p.t),
        getTimestamps: d => d.timestamps,
        getColor: d => {
          if (type_type === "pre") {
            switch (d.gym_time_segment) {
              case "Early":
                return [253, 128, 93];
              case "Mid":
                return [51, 153, 51, 100];
              case "Late":
                return [0, 153, 255, 100];
            }
          } else {
            switch (d.gym_time_segment) {
              case "Early":
                return [254, 187, 169];
              case "Mid":
                return [83, 198, 83, 100];
              case "Late":
                return [77, 184, 255, 100];
            }
          }
        },
        opacity: opacity,
        widthMinPixels: 5,
        rounded: true,
        trailLength: 50,
        currentTime: this.counter
      });
    },
    generateIconLayer(gyms) {
      const layer = new IconLayer({
        id: "icon-layer-" + this.counter,
        data: gyms,
        pickable: false,
        // iconAtlas and iconMapping are required
        // getIcon: return a string
        iconAtlas: "images/icon-atlas.png",
        iconMapping: ICON_MAPPING,
        getIcon: () => "marker",
        sizeScale: 15,
        getPosition: d => {
          return [d.position.longitude, d.position.latitude, 172];
        },
        getSize: () => 5,
        getColor: () => [255, 0, 0]
      });
      return layer;
    }
  }
};
</script>

<style lang="scss" scoped>
#deck-canvas, #map {
  width: calc(80vw - 40px);
  margin-left: 20vw;
}
#container {
  // position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#container > #map, #container > canvas {
  position: absolute;
  top: 0px;
  right: 0;
  width: calc(80vw - 40px);
  height: 100%;
}
#tooltip {
  font-size: 36px;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  width: 4em;
  height: 1em;
  top: 10px;
  left: calc(50% - 2em);
  background-color: #fcf3d9;
  text-align: center;
  border: 1px dashed #777;
  line-height: 1em;
}
.loading-screen {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fcf3d9;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
.details-srceen {
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fcf3d9;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
div.gym_heatmap {
  width: 100%;
  // max-width: 1200px;
  background-image: url('~@/assets/gym_heatmap.jpg');
  height: 100%;
  background-size: cover;
  position: relative;
}
div.loading-screen-text {
  position: absolute;
  bottom: 15vh;
  left: 10vw;
  h1, h3 {
    color: white;
  }
  h1 {
    font-size: 2rem;
  }
  h3 {
    font-size: 1.4rem;
  }
}
.get-started {
  position: absolute;
  bottom: 7vh;
  left: calc(10vw + 7em);
}
.nextButton {
  position: absolute;
  right: 10em;
  bottom: 5vw;
}
.replayButton {
  position: absolute;
  right: 20em;
  bottom: 5vw;
}
.oniracom-logo {
  max-height: 250px;
}
</style>
